import { Navigate } from "react-router-dom";

/**
 * Route protégée avec vérification du token ET du rôle.
 *
 * Usage:
 *   <ProtectedRoute role="admin">...</ProtectedRoute>
 *   <ProtectedRoute role="syndicat">...</ProtectedRoute>
 *   <ProtectedRoute role="pharmacien">...</ProtectedRoute>
 *   <ProtectedRoute>...</ProtectedRoute>  // juste authentifié
 */
const ProtectedRoute = ({ children, role }) => {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("role") || "";

  // Pas authentifié → rediriger selon le rôle attendu
  if (!token) {
    if (role === "admin") return <Navigate to="/admin-login" replace />;
    return <Navigate to="/login" replace />;
  }

  // Vérification du rôle si spécifié
  if (role) {
    const normalizedRole = role.toLowerCase();
    const normalizedUserRole = userRole.toLowerCase();

    if (!normalizedUserRole.includes(normalizedRole)) {
      // Mauvais rôle → rediriger vers la bonne page selon le rôle réel
      if (normalizedUserRole.includes("syndicat")) return <Navigate to="/syndicat" replace />;
      if (normalizedUserRole.includes("pharmacien")) return <Navigate to="/pharmacist" replace />;
      if (normalizedUserRole.includes("admin")) return <Navigate to="/admin" replace />;
      return <Navigate to="/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
